import { fPrice } from '@trustpad/launchpad/dist/pool/utils';

import * as React from 'react';

import { TMain } from '~common/UI';
import { DateTimeFormat, ZERO_BN } from '~config/constants';
import { usePool, useSaleRate, useSaleTimeline } from '~features/pools';
import {
  SaleRegistrationStartEndItem,
  SaleStartEndItem,
} from '~features/pools/components/PoolSecondaryBlock/SaleDatesItems';
import { capitalize, fNum, toEth } from '~utils';

import { Token } from '../../../../types';
import { PoolToken, Sale, SaleStatus } from '../../types';
import { getHardCap } from '../../utils';
import { ListItem } from './InfoListItem';
import { MaxContribution } from './MaxContribution';
import { Title } from './UI';

export function SaleSection() {
  const {
    pool: { sale, token, fundToken, access },
    isFinished,
  } = usePool();

  const { start, end, registerStart, registerEnd, fcfsStart } =
    useSaleTimeline();

  let fcfsStartCalc = end ? end.clone().subtract(1, 'hour') : null;

  function getMinAllocation() {
    if (sale.limits === null) {
      return 'TBA';
    }
    if (sale.limits?.min?.gtn(0)) {
      return `${toEth(sale.limits?.min, 4)} ${fundToken.symbol}`;
    }
    return 'not limited';
  }

  return (
    <div className="space-y-3">
      <Title>Pool Details</Title>

      <div className="flex flex-col md:flex-row flex-wrap">
        <div className="md:w-1/2">
          <ListItem label="Access Type">
            {false
              ? 'BLACK'
              : sale.isTiered
                ? 'Levels'
                : access === 'levels_fcfs'
                  ? 'Levels FCFS'
                  : capitalize(access)}
          </ListItem>
        </div>
        <div className="md:w-1/2">
          <ListItem label="Hard Cap">{getHardCap(sale, fundToken)}</ListItem>
        </div>
      </div>

      <ul>
        {!(isFinished && !sale.rate) && (
          <PoolRateItem sale={sale} token={token} fundToken={fundToken} />
        )}

        {sale.limits?.min?.gt(ZERO_BN) && (
          <ListItem label="Min. contribution">{getMinAllocation()}</ListItem>
        )}

        <SaleStartEndItem start={start} end={end} />
        {sale.status < SaleStatus.open && (
          <SaleRegistrationStartEndItem
            start={registerStart}
            end={registerEnd}
          />
        )}

        {(fcfsStart || fcfsStartCalc) && (
          <ListItem label="FCFS Opens">
            {(fcfsStart || fcfsStartCalc).format(DateTimeFormat.noYear)}
          </ListItem>
        )}

        <MaxContribution />
      </ul>
    </div>
  );
}

function PoolRateItem({
  sale,
  token,
  fundToken,
}: {
  sale: Sale;
  token: PoolToken;
  fundToken: Token;
}) {
  const { tokensPerCurrency, currencyPerToken } = useSaleRate();

  if (!sale.rate) {
    return (
      <ListItem label="Swap Rate">
        <TMain>TBA</TMain>
      </ListItem>
    );
  }

  if (sale.rateString) {
    return <ListItem label="Swap Rate">{sale.rateString}</ListItem>;
  }

  return (
    <ListItem label="Swap Rate">
      <TMain>1 {token.symbol}</TMain> ={' '}
      <TMain>{fNum(currencyPerToken, 10)}</TMain>
      {' | '}
      <TMain>
        {fNum(tokensPerCurrency, 10)} {token.symbol}
      </TMain>{' '}
      per <TMain>1 {fundToken.symbol}</TMain>
    </ListItem>
  );
}
